<template>
  <section class="wrap">
    <!-- 进度条 -->
    <div style="margin: 10px 0 20px; width: 900px" v-show="stepState == 1">
      <el-steps :active="0" finish-status="success" align-center>
        <el-step title="基础信息"></el-step>
        <el-step title="分享设置"></el-step>
      </el-steps>
    </div>
    <el-form
      v-if="stepState == 1"
      ref="form"
      :model="form"
      :rules="rules"
      label-width="200px"
      style="paddingbottom: 50px"
    >
      <!-- 基础信息 -->
      <el-card class="self-el-card">
        <p class="title">基本信息</p>
        <el-form-item label="课程源类型" class="is-required">
          <el-radio-group v-model="form.type">
            <template v-if="form.userType == 2">
              <el-radio :label="item.value" v-for="item in typeList" :key="item.value">{{ item.label }} </el-radio>
            </template>
            <template v-else>
              <el-radio :label="item.value" v-for="item in typeList_mom" :key="item.value"> {{ item.label }}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="直播模板" class="is-required"
         v-if="form.type === 1">
          <el-radio-group v-model="form.liveTemplate">
            <el-radio :label="item.value" v-for="item in liveTemplateList" :key="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="课程源名称" class="is-required">
          <el-input v-model.trim="form.title" placeholder="请输入课程源名称" class="width_short" maxlength="99">
          </el-input>
          <span class="desc">50字以内</span>
        </el-form-item>
        <el-form-item label="目录标签">
          <el-input v-model.trim="form.typeText" placeholder="请输入课程源标签" class="width_short" maxlength="5">
          </el-input>
          <span class="desc" v-show="form.type === 1">5字以内,默认为【直播】</span>
          <span class="desc" v-show="form.type === 2">5字以内,默认为【视频】</span>
          <span class="desc" v-show="form.type === 8">5字以内,默认为【音频】</span>
        </el-form-item>
        <el-form-item label="主讲医生" class="is-required">
          <el-input v-model="form.teacher.name" class="width_short" maxlength="30"></el-input>
          <el-button @click="openDocSelectDialog">请选择</el-button>
        </el-form-item>
        <el-form-item label="内容标签" v-if="form.userType === 2">
          <el-button @click="openTagDialog">请选择</el-button>
          <span class="desc">主要用于搜索和精准推送</span>
          <div class="tag-wrap">
            <el-tag
              closable
              type="success"
              v-for="(item, index) in form.choicedTag"
              :key="index"
              class="self-el-tag"
              @close="cancleChoiceTag(index)"
            >
              {{ item.name }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="上架时间" class="is-required">
          <el-date-picker
            v-model="form.onlineTime"
            type="datetime"
            :disabled="!form.offline && this.PAGEKEY !== 'courseSourceAdd'"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
          -
          <el-date-picker
            v-model="form.offlineTime"
            type="datetime"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
          <span style="color: grey; margin: 0 10px; opacity: 0.8"
            >上架时间不能是过去时间，如未填写下架时间，则不自动下架</span
          >
        </el-form-item>
        <el-form-item label="VIP按时长分酬">
          <el-switch
            v-model="form.vipShare"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>
          <span class="desc">开启后，将计算到讲师的分酬收益</span>
        </el-form-item>
        <el-form-item label="团购消息推送">
          <el-switch
            v-model="form.fakeGroupBuyCard"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>
          <span class="desc">开启后，将推送团购消息至直播间</span>
        </el-form-item>
        <el-form-item label="难度" class="is-required">
          <el-select v-model="form.difficulty" placeholder="请选择" size="small">
            <el-option v-for="item in difficultyList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-card>

      <!-- 直播流 -->
      <el-card class="self-el-card" v-if="form.type == 1 && form.rtmpType == 6">
        <p class="title">APP流地址</p>
        <el-form-item label="推流">
          <el-input placeholder="推流地址" v-model.trim="form.rtmpWrite" style="width: 500px" disabled>
            <el-button slot="append" @click="copy('rtmpWrite')">复制</el-button>
          </el-input>
          <el-input
            v-model.trim="form.rtmpWrite"
            id="rtmpWrite"
            style="position: absolute; left: 0; z-index: -1"
          ></el-input>
        </el-form-item>
        <el-form-item label="rtmp拉流">
          <el-input placeholder="rtmp拉流地址" v-model.trim="form.rtmpRead" style="width: 500px" id="rtmpRead">
            <el-button slot="append" @click="copy('rtmpRead')">复制</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="hls拉流">
          <el-input placeholder="hls拉流地址" v-model.trim="form.hisRead" style="width: 500px" id="hisRead">
            <el-button slot="append" @click="copy('hisRead')">复制</el-button>
          </el-input>
        </el-form-item>
      </el-card>

      <!-- 开课信息 -->
      <el-card class="self-el-card" v-if="form.type == 1">
        <p class="title">直播设置</p>
        <div>
          <el-form-item label="直播类型" class="is-required" v-if="form.type == 1 && form.rtmpType == 6">
            <el-select v-model="form.category" placeholder="请选择">
              <el-option v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传视频" class="is-required" v-show="form.category == 2">
            <upload
              accept="video/mp4"
              :isShowProgress="true"
              :url="form.liveVideoUrl"
              :bucketName="commonUrl.qNBucketName"
              @on-before="uploadLiveVideoBefore"
              @on-success="uploadLiveVideoSuccess"
            >
              <el-button slot="upload">请选择</el-button>
            </upload>
            <span style="color: #aaa">支持格式MP4</span>
          </el-form-item>
          <el-form-item label="开课时间" class="is-required">
            <el-date-picker
              v-model="form.planTime"
              type="datetimerange"
              align="center"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['20:00:00', '21:00:00']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="宣导视频">
            <upload
              accept="video/mp4"
              :isShowProgress="true"
              :url="form.propagandaVideo.url"
              @on-success="uploadPropagandaSuccessCb"
            >
              <el-button slot="upload">请选择</el-button>
            </upload>
            <el-checkbox v-model="propagandaCyclePlay">是否循环</el-checkbox>
            <el-button icon="el-icon-delete" @click="clearPropagandaVideo"></el-button>
          </el-form-item>
          <el-form-item label="直播间封面" v-if="form.type == 1 && form.rtmpType == 6">
            <el-upload
              class="avatar-uploader"
              :action="commonUrl.uploadImg"
              :headers="commonUrl.headers"
              :data="mediaObj"
              :multiple="false"
              :on-success="(e) => uploadSuccess('liveHomeImg', e)"
              :show-file-list="false"
            >
              <div v-if="form.liveHomeImg" class="avatar trash">
                <img :src="commonUrl.imgPrefix_qN + form.liveHomeImg" />
                <div class="trashdom"></div>
                <i class="el-icon-delete avatar_edit" @click.stop="deleteCover('liveHomeImg')"></i>
              </div>
              <i v-else class="iconfont icon-picture-add"></i>
            </el-upload>
            <span>图片比例16:9，建议750*422</span>
          </el-form-item>
          <el-form-item label="直播间背景图" v-if="form.type == 1 && form.rtmpType == 6">
            <el-upload
              class="avatar-uploader"
              ref="bgUpload"
              accept="image"
              :action="commonUrl.uploadImg"
              :headers="commonUrl.headers"
              :data="mediaObj"
              :multiple="false"
              :show-file-list="false"
              :before-upload="beforeUploadBgCover"
              :on-success="(e) => uploadSuccess('backgroundUrl', e)"
            >
              <div v-if="form.backgroundUrl" class="avatar trash" style="width: auto">
                <img :src="commonUrl.imgPrefix_qN + form.backgroundUrl" />
                <div class="trashdom"></div>
                <i class="el-icon-delete avatar_edit" @click.stop="deleteCover('backgroundUrl')"></i>
              </div>
              <i v-else class="iconfont icon-picture-add"></i>
            </el-upload>
            <span style="color: red">*图片必须有alpha通道，如不清楚，切勿私自更改，图片比例16:9</span>
          </el-form-item>
          <el-form-item label="直播背景图" v-if="form.liveTemplate == 1">
            <el-upload
              class="avatar-uploader"
              ref="bgUpload"
              accept="image"
              :action="commonUrl.uploadImg"
              :headers="commonUrl.headers"
              :data="mediaObj"
              :multiple="false"
              :show-file-list="false"
              :before-upload="beforeUploadBgCover"
              :on-success="(e) => uploadSuccess('liveBgPic', e)"
            >
              <div v-if="form.liveBgPic" class="avatar trash" style="width: auto">
                <img :src="commonUrl.imgPrefix_qN + form.liveBgPic" />
                <div class="trashdom"></div>
                <i class="el-icon-delete avatar_edit" @click.stop="deleteCover('liveBgPic')"></i>
              </div>
              <i v-else class="iconfont icon-picture-add"></i>
            </el-upload>
            <span>图片比例9:19，eg:750*1626</span>
          </el-form-item>
          <!-- 主持人 & 小助手 -->
          <el-form-item label="主持人" v-if="form.type == 1 || form.type == 3">
            <el-input v-model="form.assistant.name" class="width_short" maxlength="30" readonly>
              <el-button slot="append" icon="el-icon-delete" @click="form.assistant = { id: '', name: '' }"></el-button>
            </el-input>
            <el-button @click="openAssistantSelectDialog">请选择</el-button>
          </el-form-item>
          <el-form-item label="更多讲者">
            <el-button type="primary" @click="openDocAll('moredoc')" size="small">选择讲者</el-button>
            <p>
              <el-tag
                v-for="(item, index) in form.teacahrIds"
                :key="index"
                style="margin: 0 4px 4px 0"
                :closable="true"
                @close="removeTag(index)"
              >
                {{ item.userName }}
              </el-tag>
            </p>
          </el-form-item>
          <el-form-item label="开课短信通知" class="is-required">
            <div>
              <el-switch
                v-model="form.shortMessage"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </div>
          </el-form-item>
          <el-form-item label="课堂答疑" class="is-required" v-if="form.type == 1 && form.userType != 1">
            <div>
              <el-switch
                v-model="form.allowAsk"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </div>
          </el-form-item>
          <el-form-item label="公开直播" class="is-required" v-if="form.type == 1 && form.userType != 1">
            <div>
              <el-switch
                v-model="form.overt"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <span style="vertical-align: middle">开启后将会呈现在首页</span>
            </div>
          </el-form-item>
          <el-form-item label="APP授课样式" class="is-required teachStyle"
           v-if="form.type == 1 && form.rtmpType == 6 && form.liveTemplate !== 1">
            <div
              :class="[form.appGiveStyle == 1 ? 'active' : '']"
              @click="form.appGiveStyle = 1"
              style="margin-right: 10px"
            >
              <img src="http://file.ibabygroup.cn/Mobbig/image/gpD5G2CvGjHJKDYRCpj7v7PuCB5nrZHL.jpg" />
              <img src="http://file.ibabygroup.cn/Mobbig/image/8MmTHyCRhEZVnaJvRj8tCPxYC6sXsSJz.jpg" />
              <p>主次呈现</p>
            </div>
            <div :class="[form.appGiveStyle == 2 ? 'active' : '']" @click="form.appGiveStyle = 2">
              <img src="http://file.ibabygroup.cn/Mobbig/image/jrVZ6SNkbg7RHz3MNBLwB2uJrw63fu9K.jpg" />
              <img src="http://file.ibabygroup.cn/Mobbig/image/TxEGLtnUaxreCfvRvTuXyXMeZj523q3m.jpg" />
              <p>重叠呈现</p>
            </div>
          </el-form-item>
          <el-form-item label="是否支持游客观看" class="is-required"
           v-if="form.liveTemplate !== 1">
            <el-select v-model="form.isTouristWatch" placeholder="请选择" size="small">
              <el-option
                v-for="item in isTouristWatchOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.value == 1 && form.isOnlyVipWatch"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="显示“VIP免费回放”按钮">
            <el-switch
              @click.native="handleClickSwitch('isShowVipFreeReview')"
              :disabled="form.isOnlyVipWatch && !form.isShowVipFreeReview"
              v-model="form.isShowVipFreeReview"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
            ></el-switch>
          </el-form-item>
          <el-row>
            <el-col :span="5">
              <el-form-item label="直播免费">
                <el-switch
                  @click.native="handleClickSwitch('liveFree')"
                  :disabled="form.isOnlyVipWatch && !form.liveFree"
                  v-model="form.liveFree"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="直播仅VIP观看"
               v-if="form.liveTemplate !== 1">
                <el-switch
                  @click.native="handleClickSwitch('isOnlyVipWatch')"
                  @change="handleOnlyVipWatchChange"
                  :disabled="form.liveFree || form.isShowVipFreeReview"
                  v-model="form.isOnlyVipWatch"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="VIP卡种"
               v-show="form.liveTemplate !== 1">
                <multipe-select
                  :options="vipCardTypes"
                  :selectAllValue="-1"
                  labelKey="name"
                  valueKey="id"
                  :disabled="!form.isOnlyVipWatch"
                  @onSelectedChange="handleVipCardTypeChange"
                  ref="vipCardTypeSelectRef"
                  placeholder="请选择VIP卡种"
                  size="small"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="免费回放时长">
            <el-input-number placeholder="请输入" v-model="form.freeReviewDuration" :precision="0" :min="0">
            </el-input-number>
            <span>小时</span>
            <span class="desc">直播结束后，允许免费回放时长，0小时为结束后立即收费</span>
          </el-form-item>
          <!-- wap to app -->
          <el-form-item label="WAP引导按钮1文案">
            <el-input
              v-model.trim="form.wapGuideButtonText1"
              placeholder="WAP引导按钮1文案"
              class="width_short"
              maxlength="20"
            >
            </el-input>
            <span class="desc">字数限制20字以内</span>
          </el-form-item>
          <el-form-item label="WAP引导按钮2文案">
            <el-input
              v-model.trim="form.wapGuideButtonText2"
              placeholder="WAP引导按钮2文案"
              class="width_short"
              maxlength="12"
            >
            </el-input>
            <span class="desc">字数限制12字以内</span>
          </el-form-item>
          <el-form-item label="WAP直播聊天框文案">
            <el-input
              v-model.trim="form.wapLiveChatText"
              placeholder="WAP直播聊天框文案"
              class="width_short"
              maxlength="10"
            >
            </el-input>
            <span class="desc">字数限制10字以内</span>
          </el-form-item>
          <el-form-item label="WAP直播回顾">
            <div>
              <el-switch
                v-model="form.isOpenWapReview"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="true"
                :inactive-value="false"
              ></el-switch>
              <span style="vertical-align: middle">打开后即WAP可回顾直播</span>
            </div>
          </el-form-item>
          <el-form-item label="WAP引导视频" v-show="!form.isOpenWapReview">
            <upload
              accept="video/mp4"
              :isShowProgress="true"
              :url="form.wapGuideVideoUrl"
              @on-success="uploadWapGuideVideoSuccessCb"
            >
              <el-button slot="upload">请选择</el-button>
            </upload>
            <el-checkbox v-model="wapGuideVideoCyclePlay">是否循环</el-checkbox>
            <el-button icon="el-icon-delete" @click="clearWapGuideVideo"></el-button>
          </el-form-item>
        </div>
      </el-card>
      <!-- 签到设置 -->
      <el-card class="self-el-card" v-if="form.type == 1 && form.liveTemplate !== 1">
        <p class="title">签到设置</p>
        <el-form label-width="200px">
          <el-form-item label="签到">
            <el-switch
              v-model="form.signSwitch"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
          <el-form-item label="签到时间设置" v-if="form.signSwitch">
            <div class="sign_time">
              <div class="sign_start">
                <div>
                  直播开播签到
                  <el-input class="time_input" size="small" v-model="form.signInTime"></el-input>分钟内
                </div>
                <div style="margin-left: 50px">
                  签到提示文案
                  <el-input
                    class="tips_input"
                    size="small"
                    v-model="form.signInTips"
                    maxlength="20"
                    placeholder="请输入..."
                  ></el-input
                  >20字内
                </div>
              </div>
              <div class="sign_start">
                <div>
                  直播结束签退
                  <el-input class="time_input" size="small" v-model="form.signOutTime"></el-input>分钟内
                </div>
                <div style="margin-left: 50px">
                  签退提示文案
                  <el-input
                    class="tips_input"
                    size="small"
                    v-model="form.signOutTips"
                    maxlength="20"
                    placeholder="请输入..."
                  ></el-input
                  >20字内
                </div>
              </div>
            </div>
            <div class="sign_time custom_sign">
              <div style="margin-right: 15px">自定义签到时间</div>
              <div>
                <div class="sign_start" v-for="(item, index) in form.custom" :key="index">
                  <el-date-picker
                    size="small"
                    v-model="item.time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="timePickerChange(item, index)"
                    @input="timePickerChange(item, index)"
                    align="right"
                  >
                  </el-date-picker>
                  <div style="margin-left: 30px">
                    <span>签到提示文案</span>
                    <el-input
                      class="tips_input"
                      size="small"
                      v-model="item.text"
                      maxlength="20"
                      placeholder="请输入..."
                    ></el-input
                    >20字内
                  </div>
                  <i
                    @click="deleteCustomTime(index)"
                    v-if="form.custom.length > 1"
                    style="margin-left: 15px"
                    class="el-icon-close"
                  ></i>
                </div>
                <el-button size="small" @click="addCustomTime">添加时间</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </el-card>
      <!-- 回放设置 -->
      <el-card class="self-el-card" v-if="form.type == 1">
        <p class="title">回放设置</p>
        <el-form label-width="200px">
          <el-form-item label="是否回放" class="is-required">
            <el-select v-model="form.playBack" placeholder="请选择" size="small">
              <el-option v-for="item in playBackOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span class="desc">播放时间不足10分钟时，暂停时不会生成回顾</span>
          </el-form-item>
          <el-form-item label="回放来源" class="is-required" v-if="form.playBack == 2 || form.playBack == 3">
            <el-select v-model="form.playbackSource" placeholder="请选择" size="small">
              <el-option v-for="item in replaySourceList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回放地址" v-if="form.playbackSource == 2">
            <el-input v-model.trim="form.playbackUrl" placeholder="请输入..." class="width_short" maxlength="500">
            </el-input>
            <span class="desc">500个字以内，第三方生成地址后再添加</span>
          </el-form-item>
        </el-form>
      </el-card>
      <!-- APP值守 -->
      <el-card class="self-el-card" v-if="form.type == 1">
        <p class="title">APP值守</p>
        <el-form label-width="200px">
          <el-form-item label="APP值守人员">
            <el-button size="small" @click="openDocAll('watchMan')">请选择...</el-button>
            <el-tag
              v-if="form.watchMan && form.watchMan.id"
              style="margin: 0 4px 4px 0"
              :closable="true"
              @close="removeAppTag"
            >
              {{ form.watchMan.name }} {{ form.watchMan.phone }}
            </el-tag>
          </el-form-item>
        </el-form>
      </el-card>
      <!-- 入会密码 -->
      <el-card class="self-el-card" v-if="form.type == 1 && form.liveTemplate !== 1">
        <p class="title">入会密码</p>
        <el-form label-width="200px">
          <el-form-item label="设置观看密码">
            <el-switch
              v-model="form.passwordSwitch"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
            <template v-if="form.passwordSwitch">
              <el-input
                v-model="form.password"
                maxlength="4"
                size="small"
                style="width: 200px; margin-left: 50px"
                placeholder="请输入..."
              ></el-input>
              <span class="desc">请设置4位观看密码</span>
            </template>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="self-el-card">
        <p class="title">版权</p>
        <el-form label-width="200px">
          <el-form-item label="版权授权">
            <el-switch
              v-model="copyright.isCopyright"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
            ></el-switch>
          </el-form-item>
          <el-form-item label="主协议编号">
            <el-input v-model.trim="copyright.protocolCode" placeholder="请输入主协议编号" class="width_short" maxlength="9999">
            </el-input>
          </el-form-item>
          <el-form-item label="确认单编号">
            <el-input v-model.trim="copyright.confirmCode" placeholder="请输入确认单编号" class="width_short" maxlength="9999">
            </el-input>
          </el-form-item>
          
        </el-form>
          <el-form :inline="true" label-width="90px"
           style="margin-left: 110px" v-if="copyright.isCopyright">
            <el-form-item label="含金量评级">
              <el-input v-model.trim="copyright.copyrightGoldLevel" placeholder="请输入含金量评级" class="width_short_half" maxlength="9999">
              </el-input>
            </el-form-item>
            <el-form-item label="类别">
              <el-input v-model.trim="copyright.copyrightCategory" placeholder="请输入类别" class="width_short_half" maxlength="9999">
              </el-input>
            </el-form-item>
            <el-form-item label="级别">
              <el-input v-model.trim="copyright.copyrightLevel" placeholder="请输入类别" class="width_short_half" maxlength="9999">
              </el-input>
            </el-form-item>
            <el-form-item label="方式">
              <el-input v-model.trim="copyright.copyrightMethod" placeholder="请输入方式" class="width_short_half" maxlength="9999">
              </el-input>
            </el-form-item>
            <el-form-item label="使用">
              <el-input v-model.trim="copyright.copyrightUse" placeholder="请输入使用" class="width_short_half" maxlength="9999">
              </el-input>
            </el-form-item>
            <el-form-item label="期限">
              <el-input v-model.trim="copyright.copyrightTimeLimit" placeholder="请输入期限" class="width_short_half" maxlength="9999">
              </el-input>
            </el-form-item>
            <el-form-item label="范围">
              <el-input v-model.trim="copyright.copyrightRange" placeholder="请输入范围" class="width_short_half" maxlength="9999">
              </el-input>
            </el-form-item>
            <el-form-item label="再授权">
              <el-input v-model.trim="copyright.copyrightReauthorize" placeholder="请输入再授权" class="width_short_half" maxlength="9999">
              </el-input>
            </el-form-item>
          </el-form>
      </el-card>
      <!-- 自定义字段 -->
      <el-card class="self-el-card" v-if="(form.type == 2 || form.type == 8) && form.userType === 2">
        <p class="title">自定义字段</p>
        <el-form label-width="200px">
          <el-form-item v-for="(item, index) in fields" :key="index" :label="'字段' + (index + 1)">
            <el-input placeholder="标题..." class="width_short_half" v-model.trim="item.title"></el-input>
            <el-input placeholder="请输入" class="width_short" v-model.trim="item.content" maxlength="50"> </el-input>
            <el-button size="small" type="danger" @click="deleteField(index)" v-if="index != 0">删除</el-button>
            <span class="desc">50字以内</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="addField">添加+</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="self-el-card" v-show="form.type == 2 || form.type == 8 || form.userType == 1">
        <form id="form1">
          <input id="uploadVideoNow-file" type="file" style="display: none" />
        </form>
        <el-form label-width="200px">
          <!-- 视频上传 -->
          <div v-show="form.type == 2 || form.userType === 1">
            <p style="margin-bottom: 40px">
              <span>{{ form.type == 2 || form.userType == 1 ? '视频上传' : '回顾视频' }}</span>
              <span style="font-size: 10px">(请在直播结束后，上传剪切好的视频)</span>
            </p>
            <el-form-item
              label="上传视频"
              prop="upload"
              :class="[form.type == 2 || form.type == 8 ? 'is-required' : '']"
            >
              <el-progress
                class="self-progress"
                :text-inside="true"
                :stroke-width="18"
                :percentage="vodProgresNum"
                v-if="showVodProgres"
              ></el-progress>
              <el-input v-model.trim="form.vodName" class="width_short" maxlength="30" readonly v-else> </el-input>
              <el-button @click="choiceVodHandle">请选择</el-button>
              <span class="desc">支持MP4格式，视频请压缩后上传</span>
            </el-form-item>
            
            <!-- <el-form-item label="视频模板" class="is-required">
              <el-radio-group v-model="form.videoTemplate">
                <el-radio :label="item.value" v-for="item in liveTemplateList" :key="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item> -->

            <el-form-item label="试看时长" v-show="(form.type == 2 || form.type == 8) && form.userType === 2">
              <el-input-number placeholder="请输入" v-model="form.freeWatchTime" :precision="0" :min="0">
              </el-input-number>
              <span>分钟</span>
              <span class="desc">如不填写：10分钟以上的视频，默认试看2分钟，10分钟以下的视频默认不试看；0为不试看</span>
            </el-form-item>
          </div>

          <!-- 音频上传 -->
          <div v-show="form.type == 8">
            <p style="margin-bottom: 40px">音频上传</p>
            <el-form-item label="上传音频：" class="is-required">
              <el-progress
                class="self-progress"
                :text-inside="true"
                :stroke-width="18"
                :percentage="vodProgresNum"
                v-if="showVodProgres"
              ></el-progress>
              <el-input v-model.trim="form.audioName" class="width_short" maxlength="30" readonly v-else> </el-input>
              <el-button @click="choiceVodHandle">请选择</el-button>
              <span class="desc">支持MP3格式</span>
            </el-form-item>
          </div>

          <!-- 添加节点 -->
          <el-form-item label="添加节点" v-if="(form.type == 2 || form.type == 8) && form.userType === 2">
            <el-card>
              <p v-for="(item, index) in anchors" :key="index">
                <span>起始时间</span>
                <el-input-number
                  placeholder="分钟"
                  class="width_short_half"
                  v-model.trim="item.minute"
                  :precision="0"
                  :min="0"
                  :max="60"
                  size="small"
                ></el-input-number
                >分钟
                <el-input-number
                  placeholder="秒钟"
                  class="width_short_half"
                  v-model.trim="item.second"
                  :precision="0"
                  :min="0"
                  :max="60"
                  size="small"
                ></el-input-number
                >秒钟
                <span style="margin-left: 60px">节点名称</span>
                <el-input
                  placeholder="请输入"
                  class="width_short_half"
                  size="small"
                  maxlength="30"
                  v-model.trim="item.title"
                ></el-input>
                <el-button type="danger" size="small" @click="deleteVideo(index)">删除</el-button>
              </p>
              <p class="desc">时间不超出视频最长时间，标题30字以内</p>
              <el-button type="primary" style="margin: 20px" @click="addVideo">添加+</el-button>
            </el-card>
          </el-form-item>
        </el-form>
      </el-card>

      <!-- 富文本框 -->
      <el-card v-show="(form.type == 2 || form.type == 8 || form.webType == 2) && form.userType === 2">
        <el-form label-width="200px">
          <p style="margin-bottom: 40px">内容</p>
          <el-form-item label="模块名称">
            <el-input
              class="width_short"
              placeholder="请输入"
              size="small"
              v-model="form.moduleName"
              clearable
            ></el-input>
            <span class="desc">8个字以内</span>
          </el-form-item>
          <el-form-item label="内容">
            <v-editor
              :defaultMsg="form.webPic"
              :config="editorDefault.config"
              ref="ditorWeb"
              :editorId="editorDefault.editorId"
              v-if="editorDefault.editorId"
            ></v-editor>
          </el-form-item>
        </el-form>
      </el-card>
    </el-form>

    <!-- 进度条 -->
    <div style="margin: 10px 0 20px; width: 900px" v-show="stepState == 2">
      <el-steps :active="1" finish-status="success" align-center>
        <el-step title="基础信息"></el-step>
        <el-step title="分享设置"></el-step>
      </el-steps>
    </div>
    <!-- 第二步 -->
    <el-form ref="thirdStep" v-show="stepState == 2" :model="form" label-width="200px" style="padding-top: 20px">
      <!-- h5分享 -->
      <el-card class="courseList">
        <span>h5分享</span>
        <el-form-item label="分享标题：" prop="shareTitle">
          <el-input v-model.trim="form.shareTitle" class="width_short" maxlength="50"> </el-input>
          <span class="desc">20字以内</span>
        </el-form-item>
        <el-form-item label="分享描述：" prop="shareDesc">
          <el-input v-model.trim="form.shareDesc" class="width_short" maxlength="50"> </el-input>
          <span class="desc">20字以内</span>
        </el-form-item>
        <el-form-item label="分享封面图：" prop="shareImg">
          <el-upload
            class="avatar-uploader"
            :action="commonUrl.uploadImg"
            :data="mediaObj"
            :multiple="false"
            :on-success="shareImgSuccess"
            :before-upload="beforeUpload"
            :headers="commonUrl.headers"
            :show-file-list="false"
          >
            <img v-if="form.shareImg" class="avatar" :src="commonUrl.imgPrefix_qN + form.shareImg" />
            <i v-else class="iconfont icon-picture-add"></i>
          </el-upload>
          <div class="desc">图片比例1:1，建议200*200，大小控制128k以内</div>
        </el-form-item>
      </el-card>
    </el-form>
    <el-form style="margin-top: 40px">
      <el-form-item label-width="200px" style="padding-top: 20px">
        <el-button type="warning" v-show="stepState == 2" @click="back">上一步</el-button>
        <el-button
          type="primary"
          v-show="stepState == 2"
          :loading="buttonIsLoading && !isPublish"
          :disabled="buttonIsLoading && isPublish"
          @click="saveHandle"
          >保存
        </el-button>
        <el-button
          type="primary"
          v-show="stepState == 2"
          :loading="buttonIsLoading && isPublish"
          :disabled="buttonIsLoading && !isPublish"
          @click="publish"
          >保存并发布</el-button
        >
        <el-button type="primary" v-show="stepState == 1" @click="nextStep">下一步</el-button>
      </el-form-item>
    </el-form>

    <!--选择医生组件-->
    <select-doctor ref="moredoc" @select-submit="choiceMoredocCallback" :isSingle="false"></select-doctor>
    <select-doctor ref="selectDocDialog" @select-submit="choiceDocCallback"></select-doctor>
    <select-doctor ref="watchMan" @select-submit="choiceWatchManCallback"></select-doctor>

    <!--选择小助手组件-->
    <select-assistant ref="selectAssistantDialog" @select-submit="choiceAssistantCallback"></select-assistant>

    <!-- 添加标签dialog new -->
    <select-tag :isSingle="false" ref="selectTag" @select-submit="choiceTagCb"></select-tag>

    <!--选择课程源组件-->
    <select-course ref="selectCourseOrgin" :userType="2" :isSingle="true" @select-submit="choiceCourseCallback">
    </select-course>
  </section>
</template>

<script scoped>
import { mapGetters } from 'vuex'
import commonReq from '@/api/common'
import selectTag from '@/components/selectSource/selectTag'
import selectDoctor from '@/components/selectSource/selectDoctor'
import selectAssistant from '@/views/selectSource/selectAssistant'
import courseSourceReq from '@/api/contentManage/courseSource'
import selectCourse from '@/components/selectSource/selectCourseOrgin'
import upload from '@/components/upload-qiniu-v2'
import $ from '&static/UE/third-party/jquery-1.10.2.min.js'
import UE from '@/components/uedtior'
import TcVod from 'vod-js-sdk-v6'
import axios from 'axios'
import vipTypeApi from '@/api/operateManage/vipType'
import MultipeSelect from '@/components/multipeSelect.vue'

export default {
  name: 'courseSourcePage',
  props: {
    PAGEKEY: {
      type: String,
      default: () => ''
    },
    PAGEBACK: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      pageType: '',
      txurl: '',
      videoUrl: '', //计算视频时长的url
      content: '', //富文本
      tagIds: [], //标签的id数组
      tagData: [],
      uploader: null,
      //自定义字段
      fields: [
        {
          title: '',
          content: ''
        }
      ],
      //视频节点
      anchors: [],
      stepState: 1,
      commonUrl: commonReq.commonUrl,
      sourceId: '', //课程源id
      rtmpTypeList: [
        {
          value: 1,
          label: '音频直播'
        },
        {
          value: 2,
          label: '视频直播'
        },
        {
          value: 3,
          label: '录屏直播'
        }
      ],
      typeList_mom: [
        {
          value: 1,
          label: '直播'
        },
        {
          value: 2,
          label: '视频'
        }
      ],
      liveTemplateList: [
        {
          value: 0,
          label: '横屏'
        },
        {
          value: 1,
          label: '竖屏'
        }
      ],
      //直播类型选择列表
      rtmpTypeListSimple: [
        {
          value: 1,
          label: '音频直播'
        }
      ],
      typeList: [
        {
          value: 1,
          label: '直播'
        },
        {
          value: 2,
          label: '视频'
        },
        {
          value: 8,
          label: '音频'
        }
      ],
      // 直播类型
      categoryList: [
        {
          value: 1,
          label: '真人直播'
        },
        {
          value: 2,
          label: '视频直播'
        }
      ],
      // 难度
      difficultyList: [
        {
          value: '低',
          label: '低'
        },
        {
          value: '中',
          label: '中'
        },
        {
          value: '高',
          label: '高'
        }
      ],
      defaultLiveBg: 'image/livebg.png?st=' + new Date().getTime(),
      WapCyclePlay: false,
      form: {
        vipCardType: [],
        userType: 2, //用户类型 1孕妈端 2  医生端
        liveTemplate: 0, //直播模板 0 横屏 1 竖屏
        videoTemplate: 0, //视频模板 0 横屏 1 竖屏
        type: 1, //1 直播 2 视频 8 音频
        typeText: '',
        title: '', //课程源名称
        vzlink: '', //微赞链接
        webType: 1, //网页默认链接类型
        webUrl: '', //网页链接
        webPic: '', //网页内容
        teacher: {
          //主讲医生
          id: '',
          name: ''
        },
        assistant: {
          //助手
          id: '',
          name: ''
        },
        choicedTag: [],
        rtmpType: 6, // 1-音频直播 2-视频直播 3-录屏直播 6-v620新直播
        category: 1, // 直播类型  1 真人直播 2 视频直播
        planTime: [],
        shortMessage: 0, //是否开启短信提醒 0关闭 1开启
        allowAsk: 1, //是否开启答疑 0 关闭 1开启
        allowRTC: 0, //1举手 0不举手
        liveHomeImg: '', //直播间封面图
        backgroundUrl: '', // 直播间背景图
        liveBgPic: '', //直播背景图
        teacahrIds: [], //更多讲师
        appGiveStyle: 1, //1-主次呈现  2-重叠呈现

        vipShare: 0, // 是否开启了VIP按时长分酬（0-不开启 1-开启）
        fakeGroupBuyCard: false,
        liveFree: true, // 是否直播免费（0-不开启 1-开启）
        isOnlyVipWatch: false, // 是否直播进VIP观看
        freeReviewDuration: 0, // 免费回放时长(单位：小时)
        isShowVipFreeReview: true, // 是否显示【VIP免费回放】的标签（0-不开启 1-开启）
        difficulty: '低',

        vodId: '', // 视频id
        vodName: '', // 视频名称
        audioName: '', // 音频名称
        overt: 0, // 非公开直播
        freeWatchTime: undefined, // 试看
        /*推流地址*/
        rtmpRead: '',
        rtmpWrite: '',
        hisRead: '',
        transferRtmpWrite: '',
        transferRtmpRead: '',
        transferHisRead: '',
        // 宣导视频
        propagandaVideo: {
          mode: '',
          name: '',
          url: '',
          //第二步
          shareTitle: '',
          shareDescribe: '',
          shareImg: '', //分享朋友圈小图
          miniCardImg: '' //小程序卡片图
        },
        moduleName: '', //模块名称
        isTouristWatch: 0, // 是否允许游客观看
        // cutSwitch: 0, // 快剪拼接头尾
        // videoTitle: '', // 片头
        // videoEnd: '', // 片尾
        signSwitch: 0, // 签到
        signInTime: '', // 直播开播签到时间
        signInTips: '', // 直播开播签到文案
        signOutTime: '', // 直播结束签退时间
        signOutTips: '', // 直播结束签退文案
        custom: [
          {
            time: [],
            startTime: '', // 签到开始时间
            endTime: '', // 签到结束时间
            text: '' // 自定义签到文案
          }
        ],
        playBack: -1, // 是否回放
        // 回放地址
        playbackUrl: '',
        // 回放来源
        playbackSource: null,
        watchMan: {
          id: '',
          name: '',
          phone: ''
        }, // App值守人员
        passwordSwitch: 0,
        password: '', // 入会密码
        onlineTime: '', // 上架时间
        offlineTime: '', // 下架时间
        // wap引导相关↓↓↓↓↓
        wapGuideButtonText1: '', // WAP引导按钮1文案
        wapGuideButtonText2: '', // WAP引导按钮2文案
        wapLiveChatText: '', // WAP直播聊天框文案
        isOpenWapReview: true, // WAP直播回顾	默认开启
        wapGuideVideoUrl: '', // 回顾引导视频地址
        wapGuideVideoName: '', // 回顾引导视频名称
        wapGuideVideoMode: 1 // 回顾引导视频播放模式 1循环播放，2播放一次
      },
      copyright: {
        isCopyright: false, // 版权授权
        protocolCode: '', // 主协议编号
        confirmCode: '', // 确认单编号
        copyrightGoldLevel: '', // 含金量评级
        copyrightCategory: '', // 类别
        copyrightLevel: '', // 级别
        copyrightMethod: '', // 方式
        copyrightUse: '', // 使用
        copyrightTimeLimit: '', // 期限
        copyrightRange: '', // 范围
        copyrightReauthorize: '' // 再授权
      },
      isTouristWatchOptions: [
        { label: '不支持游客进入', value: 0 },
        { label: '支持游客进入', value: 1 }
      ],
      playBackOptions: [
        { label: '请选择...', value: -1 },
        { label: '不回放', value: 1 },
        { label: '实时回放', value: 2 },
        { label: '只在直播结束后回放', value: 3 }
      ],
      // 回放来源
      replaySourceList: [
        { label: '请选择...', value: null },
        { label: '呗呗医生回放流（七牛云）', value: 1 },
        { label: '第三方回放流（微赞）', value: 2 }
      ],
      rules: {
        title: [
          {
            required: true,
            message: '请输入课程源名称',
            trigger: 'blur'
          }
        ]
      },
      dialogTagShow: false,
      tagForm: {},
      showVodProgres: false, // 是否展示视频进度条
      vodProgresNum: 0,
      buttonIsLoading: false, // 保存按钮防重复点击
      isPublish: false, // 是否是保存并发布
      propagandaCyclePlay: false,
      wapGuideVideoCyclePlay: true,
      // 课件
      courseType: 1,
      coursewareList: [],
      commonReq: commonReq,
      imgPrefix: commonReq.commonUrl.imgPrefix_qN,
      videoPrefix: commonReq.commonUrl.videoPrefix,
      mediaObj: {
        mediaJson: JSON.stringify({
          type: 0
        })
      },
      // ue
      editorDefault: {
        editorId: new Date().getTime().toString(),
        defaultMsg: '',
        config: {
          initialFrameWidth: 500,
          initialFrameHeight: 550,
          autoHeightEnabled: false
        }
      },
      // 导入课件
      source: {},
      tagsStr: '',
      vipCardTypes: []
    }
  },
  computed: {
    ...mapGetters('tabs', {
      TABACTIVE: 'tabActive'
    })
  },
  activated() {
    if (this.$route.params.id === this.sourceId && this.$route.params.type === this.pageType) {
      return
    }
    // 设置课程源信息
    this.sourceId = this.$route.params.id
    this.pageType = this.$route.params.type
    if (this.sourceId) {
      this.getCourseDetail()
    }
    // 区分医生孕妈
    if (this.PAGEKEY !== 'courseSourceAdd') {
      return
    }
    if (this.TABACTIVE.parent == 'momCourse') {
      this.form.userType = 1
      this.form.allowRTC = 0
      this.form.allowAsk = 0
    } else {
      this.form.userType = 2
      this.form.allowRTC = 1
      this.form.allowAsk = 1
    }
  },
  mounted() {
    this.form.backgroundUrl = this.defaultLiveBg
    this.initUpload()
    this.getVipTypes()
  },
  components: {
    'select-doctor': selectDoctor,
    'select-assistant': selectAssistant,
    'v-editor': UE,
    selectCourse,
    upload,
    selectTag,
    MultipeSelect
  },
  methods: {
    handleVipCardTypeChange(keys, options) {
      this.form.vipCardType = keys
    },
    getVipTypes() {
      vipTypeApi.getList(1, 1000, { name: this.keyword }).then((res) => {
        if (res.Success) {
          const list = res.Data.dataList || []
          list.unshift({
            id: -1,
            name: '全部卡种'
          })
          this.vipCardTypes = list.sort((a, b) => a.id - b.id)
        }
      })
    },
    handleOnlyVipWatchChange(state) {
      if (state) {
        this.form.isTouristWatch = 0
      }
    },
    handleClickSwitch(key) {
      if (this.form[key]) return
      if (key === 'liveFree') {
        this.form.isOnlyVipWatch && this.$message.warning('已开启 直播仅VIP观看')
      }
      if (key === 'isOnlyVipWatch') {
        this.form.liveFree && this.$message.warning('已开启 直播免费')
        this.form.isShowVipFreeReview && this.$message.warning('已开启 显示“VIP免费回放”按钮')
      }
      if (key === 'isShowVipFreeReview') {
        this.form.isOnlyVipWatch && this.$message.warning('已开启 直播仅VIP观看')
      }
    },
    //input上传获取时长的方法暂定
    changeFile(ele) {
      var content = ele.videoUrl
      var url = URL.createObjectURL(content) //获取录音时长
      var audioElement = new Audio(url) //audio也可获取视频的时长
      var duration
      audioElement.addEventListener('loadedmetadata', function (_event) {
        duration = audioElement.duration
      })
    },

    //el-upload获取时长的方法
    getVideoToken(file) {
      var url = URL.createObjectURL(file)
      var audioElement = new Audio(url)
      var duration
      audioElement.addEventListener('loadedmetadata', function () {
        duration = parseInt(audioElement.duration) //时长为秒，取整
      })
    },

    //子组件传过来的值
    getData(msg) {
      let newArr = msg.map((item) => {
        return item.id
      })
      this.tagIds = newArr
      this.tagData = msg
    },
    nextStep() {
      if (this.formValidate()) {
        this.stepState = 2
        this.content = this.$refs.ditorWeb.getUEContent()
        this.form.webPic = this.$refs.ditorWeb.getUEContent()
      }
    },
    back() {
      this.stepState = 1
    },
    initUpload() {
      var getSignature = function () {
        return axios.get(courseSourceReq.getSignatureUrl()).then(function (response) {
          return response.data.data
        })
      }

      const tcUpload = new TcVod({
        getSignature: getSignature // 前文中所述的获取上传签名的函数
      })
      let _this = this
      $('#uploadVideoNow-file').on('change', function (e) {
        var mediaFile = this.files[0] // 获取文件
        // 没有文件
        if (!mediaFile) {
          return
        }
        // 视频
        if (
          (_this.form.type === 1 || _this.form.type === 2) &&
          !(mediaFile.name.includes('mp4') || mediaFile.type.includes('mp4'))
        ) {
          _this.$message.warning('请上传MP4类型的视频')
          return
        }
        // 音频
        if (_this.form.type === 8 && !mediaFile.name.includes('mp3')) {
          _this.$message.warning('请上传MP3类型的音频')
          return
        }
        _this.$message.success('准备上传中...')
        _this.uploader ? _this.uploader.cancel() : ''
        _this.uploader = tcUpload.upload({
          mediaFile: mediaFile // 媒体文件（视频或音频或图片），类型为 File
        })
        // 上传进度
        _this.uploader.on('media_progress', function (info) {
          if (!_this.showVodProgres) {
            _this.showVodProgres = true
          }
          _this.vodProgresNum = parseInt((info.percent * 100).toFixed(2))
        })
        // 上传成功
        _this.uploader.on('media_upload', function (info) {
          _this.$message.success('上传成功')
        })

        _this.uploader
          .done()
          .then(function (info) {
            _this.showVodProgres = false
            _this.form.vodId = info.fileId
            if (mediaFile.type.includes('video')) {
              _this.form.vodName = mediaFile.name
              _this.form.audioName = ''
              _this.form.webUrl = ''
            } else if (mediaFile.type.includes('audio')) {
              _this.form.vodName = ''
              _this.form.audioName = mediaFile.name
              _this.form.webUrl = info.video.url
            }
          })
          .catch(function (err) {
            console.log(err)
            _this.$message.error('上传失败，原因：', err.toString())
          })
      })
    },
    // 上传成功
    shareImgSuccess(res) {
      res = this.$apiOldResDeal(res)
      if (res.Success) {
        this.form.shareImg = res.Data.url
      } else {
        this.$message.error(res.Msg)
      }
      this.updateDom()
    },
    // 上传成功
    miniCardImgSuccess(res) {
      if (res.Success) {
        this.form.miniCardImg = res.Data.url
      } else {
        this.$message.error(res.Msg)
      }
      this.updateDom()
    },
    //添加字段
    addField() {
      let fieldItem = {
        title: '',
        content: ''
      }

      this.fields.push(fieldItem)
    },
    //删除字段
    deleteField(index) {
      this.fields.splice(index, 1)
    },
    //添加节点
    addVideo() {
      let anchors = {
        second: '',
        minute: '',
        name: '',
        time: ''
      }
      this.anchors.push(anchors)
    },

    //删除节点
    deleteVideo(index) {
      this.anchors.splice(index, 1)
    },

    // 标签绑定类型
    bindType(value) {
      switch (value) {
        case 1:
          this.form.typeText = '直播'
          break
        case 2:
          this.form.typeText = '视频'
          break
        case 8:
          this.form.typeText = '音频'
          break
        default:
          break
      }
    },

    //获取课程源详情
    getCourseDetail() {
      var params = {
        sourceId: this.sourceId
      }
      courseSourceReq.getCourseDetailById(params).then((res) => {
        if (res.Success) {
          var data = res.Data
          if (
            data.propagandaVideo &&
            data.propagandaVideo.name &&
            data.propagandaVideo.url &&
            data.propagandaVideo.mode
          ) {
            this.form.propagandaVideo = data.propagandaVideo
            if (data.propagandaVideo.mode === 'LOOP') {
              this.propagandaCyclePlay = true
            }
          } else {
            data.propagandaVideo = {
              name: '',
              url: '',
              mode: ''
            }
          }
          if (data.wapGuideVideoUrl) {
            this.wapGuideVideoCyclePlay = data.wapGuideVideoMode === 1 ? true : false
          }
          if (data.type == 4) {
            data.type = 1
          }
          let newArr = []
          let fields = data.fields || []
          //取出自定义字段中需要的属性
          fields.forEach((item) => {
            let obj = {}
            obj['title'] = item.title
            obj['content'] = item.content
            newArr.push(obj)
          })
          this.fields = newArr
          let anchors = data.anchors || []
          anchors.forEach((item) => {
            item.minute = Math.floor(item.time / 60)
            item.second = item.time % 60
          })
          this.anchors = anchors
          const isOpenWapReview = data.isOpenWapReview === null || data.isOpenWapReview === undefined
          this.form = {
            freeWatchTime:
              isNaN(data.freeWatchTime) || data.freeWatchTime === '' || data.freeWatchTime === null
                ? undefined
                : data.freeWatchTime,
            moduleName: data.moduleName,
            webPic: data.content,
            shareDesc: data.shareDescription,
            shareTitle: data.shareTitle,
            shareImg: data.shareImg || '',
            userType: data.userType, //用户类型 1 医生端 2 孕妈端
            type: data.type, //1 直播 2 视频 3线下
            liveTemplate: data.liveTemplate || 0,
            videoTemplate: data.videoTemplate || 0,
            state: data.state,
            typeText: data.typeText,
            title: data.title, //课程源名称
            onlineTime: data.onlineTime,
            offlineTime: data.offlineTime,
            offline: data.offline,
            overt: data.overt === 0 ? 0 : 1,
            difficulty: data.difficulty || '低',
            /*推流地址*/
            rtmpRead: data.rtmpRead,
            rtmpWrite: data.rtmpWrite,
            hisRead: data.hisRead,
            transferRtmpWrite: data.transferRtmpWrite,
            transferRtmpRead: data.transferRtmpRead,
            transferHisRead: data.transferHisRead,
            // 宣导视频
            propagandaVideo: data.propagandaVideo,
            teacher: {
              //主讲医生
              id: data.teacherId,
              name: data.teacherName
            },
            assistant: {
              //助手
              id: data.managerId,
              name: data.managerName
            },
            choicedTag: data.tagList,
            rtmpType: data.rtmpType,
            planTime: data.planStartTime == null ? [] : [data.planStartTime, data.planEndTime],
            category: data.category || 1,
            liveVideoUrl: data.liveVideoUrl,
            shortMessage: data.shortMessage, //是否开启短信提醒 0关闭 1开启
            allowAsk: data.allowAsk, //是否开启答疑 0 关闭 1开启
            allowRTC: data.allowRTC || 0,
            vodId: data.fileId,
            vodName: data.type === 1 || data.type === 2 ? data.fileName : '',
            audioName: data.type === 8 ? data.fileName : '',
            // v620
            teacahrIds: data.teacahrIds || [],
            liveHomeImg: data.liveHomeImg,
            backgroundUrl: data.backgroundUrl || this.defaultLiveBg,
            liveBgPic: data.liveBgPic,
            appGiveStyle: data.appGiveStyle,
            isTouristWatch: data.isTouristWatch,
            signSwitch: data.signState,
            signInTime: data.signState ? data.liveSignIn : '',
            signInTips: data.signState ? data.liveSignInText : '',
            signOutTime: data.signState ? data.liveSignOut : '',
            signOutTips: data.signState ? data.liveSignOutText : '',
            custom:
              data.signState && data.signTimes.length !== 0
                ? data.signTimes
                : [
                    {
                      time: '',
                      startTime: '',
                      endTime: '',
                      text: ''
                    }
                  ],
            playBack: data.playbackType,
            playbackUrl: data.playbackUrl || '',
            playbackSource: data.playbackSource || null,
            passwordSwitch: data.livePassword ? 1 : 0,
            password: data.livePassword,
            watchMan: {
              id: data.assistantId ? data.assistantId : '',
              name: data.assistantName ? data.assistantName : '',
              phone: data.assistantPhone ? data.assistantPhone : ''
            },
            // 首页改版
            vipShare: data.vipShare, // 是否开启了VIP按时长分酬（0-不开启 1-开启）
            fakeGroupBuyCard: data.fakeGroupBuyCard,
            liveFree: data.liveFree, // 是否直播免费（0-不开启 1-开启）
            isOnlyVipWatch: data.isOnlyVipWatch, // 是否只允许VIP观看
            freeReviewDuration: data.freeReviewDuration, // 免费回放时长(单位：小时)
            isShowVipFreeReview: data.isShowVipFreeReview,
            wapGuideButtonText1: data.wapGuideButtonText1 || '',
            wapGuideButtonText2: data.wapGuideButtonText2 || '',
            wapLiveChatText: data.wapLiveChatText || '',
            isOpenWapReview: isOpenWapReview ? true : data.isOpenWapReview, // 兼容过往课程源
            wapGuideVideoUrl: isOpenWapReview ? '' : data.wapGuideVideoUrl || '',
            wapGuideVideoName: isOpenWapReview ? '' : data.wapGuideVideoName || '',
            wapGuideVideoMode: isOpenWapReview ? undefined : data.wapGuideVideoMode,
            vipCardType: data.vipCardTypeList ? data.vipCardTypeList.map((item) => item.id) : []
          }

          Object.keys(data).forEach(key => {
            // 如果对象B有这个键，则赋值
            if (key in this.copyright) {
              this.copyright[key] = data[key];
            }
          });

          if(data.type == 1){
            this.$nextTick(() => {
              this.$refs.vipCardTypeSelectRef.setSelectedData(this.form.vipCardType)
            })
          }
          
          if (this.form.isOnlyVipWatch) {
            this.form.isTouristWatch = 0
          }
          this.form.custom.forEach((item) => {
            item.time = [item.startTime, item.endTime]
          })
        } else {
          this.$message.error(res.Msg)
        }
      })
    },

    //表单验证
    formValidate() {
      var form = this.form
      if (this.form.isOnlyVipWatch && this.form.vipCardType.length <= 0) {
        this.$message.error('已开启直播仅VIP观看，请选择VIP卡种')
        return false
      }
      if (form.title == '') {
        this.$message.error('请输入课程源名称')
        return false
      } else if (form.teacher.name == '') {
        this.$message.error('请选择主讲医生')
        return false
      }
      if (!this.form.onlineTime) {
        this.$message.error('请选择上架时间')
        return false
      }
      if (this.form.onlineTime && this.form.offlineTime) {
        const onlineTime = new Date(this.form.onlineTime).getTime()
        const offlineTime = new Date(this.form.offlineTime).getTime()
        if (onlineTime > offlineTime) {
          this.$message.error('下架时间不允许早于上架时间')
          return
        }
      }
      if (this.form.signInTime && (this.form.signInTime <= 0 || /[^\d]/.test(this.form.signInTime))) {
        this.$message.error('开播签到、结束签退只能填写正整数')
        return false
      }
      if (this.form.signOutTime && (this.form.signOutTime <= 0 || /[^\d]/.test(this.form.signOutTime))) {
        this.$message.error('开播签到、结束签退只能填写正整数')
        return false
      }
      // if (this.form.custom)
      if (this.form.passwordSwitch && /[^\d]/.test(this.form.password)) {
        this.$message.error('观看密码只允许输入数字')
        return false
      } else if (this.form.passwordSwitch && this.form.password.length !== 4) {
        this.$message.error('观看密码不足4位')
        return false
      }
      if (form.type == 1) {
        //直播
        if (!form.planTime || form.planTime.length == 0) {
          this.$message.error('请选择开课时间')
          return false
        } else if (form.rtmpType == 6 && form.category == 2 && !form.liveVideoUrl) {
          // 视频直播
          this.$message.error('请上传视频文件')
          return false
        } else if (form.isTouristWatch === -1) {
          this.$message.error('请选择是否支持游客观看')
          return false
        } else if (form.playBack === -1) {
          this.$message.error('请选择是否回放')
          return false
        } else if (form.playBack !== 1 && form.playbackSource === null) {
          // 设置微赞回放
          this.$message.error('请选择回放来源')
          return false
        } else {
          return true
        }
      } else if (this.form.type == 2) {
        // 是否传了视频
        if (!form.vodName) {
          this.$message.error('请上传视频文件')
          return false
        } else {
          return true
        }
      } else if (this.form.type == 8) {
        // 是否传了音频
        if (!form.audioName) {
          this.$message.error('请上传音频')
          return false
        } else {
          return true
        }
      }
    },

    //保存钩子
    saveHandle(extraData = {}) {
      if (this.formValidate()) {
        var form = this.form
        var tempAry = []
        for (var i = 0; i < form.choicedTag.length; i++) {
          tempAry.push(form.choicedTag[i].id)
        }
        //得到节点参数
        let anchorsArr = []
        this.anchors.forEach((item) => {
          let obj = {}
          obj['title'] = item.title
          obj['time'] = Number(item.minute * 60) + Number(item.second)
          anchorsArr.push(obj)
        })
        //得到视频时长
        var postData = {
          id: this.sourceId,
          userType: form.userType,
          type: form.type,
          liveTemplate: form.liveTemplate,
          videoTemplate: form.videoTemplate,
          rtmpReadTwo: form.vzlink,
          typeText: form.typeText,
          title: form.title,
          teacherId: form.teacher.id,
          managerId: form.assistant.id,
          managerName: form.assistant.name,
          tagIds: tempAry,
          onlineTime: form.onlineTime,
          offlineTime: form.offlineTime,
          rtmpType: form.rtmpType,
          planStartTime: this.$moment(form.planTime[0]).format('YYYY-MM-DD HH:mm:ss'),
          planEndTime: this.$moment(form.planTime[1]).format('YYYY-MM-DD HH:mm:ss'),
          shortMessage: form.shortMessage,
          allowAsk: form.allowAsk,
          allowRTC: form.allowRTC,
          anchors: anchorsArr,
          moduleName: form.moduleName,
          fields: this.fields,
          freeWatchTime:
            isNaN(form.freeWatchTime) || form.freeWatchTime === '' || form.freeWatchTime === null
              ? null
              : form.freeWatchTime,
          content: this.content || '',
          // 首页改版
          difficulty: form.difficulty, // 难度
          vipShare: form.vipShare, // 是否开启了VIP按时长分酬（0-不开启 1-开启）
          fakeGroupBuyCard: form.fakeGroupBuyCard,
          liveFree: form.liveFree, // 是否直播免费（0-不开启 1-开启）
          isOnlyVipWatch: form.isOnlyVipWatch, // 是否只允许VIP观看
          freeReviewDuration: form.freeReviewDuration, // 免费回放时长(单位：小时)
          isShowVipFreeReview: form.isShowVipFreeReview,

          // 拉流
          rtmpRead: form.rtmpRead,
          hisRead: form.hisRead,
          overt: form.overt,
          transferRtmpRead: form.transferRtmpRead,
          transferHisRead: form.transferHisRead,
          // 第二步
          shareTitle: form.shareTitle || form.title || '',
          shareDescription: form.shareDesc || '呗呗医生，让医生成长更简单',
          shareImg: form.shareImg || form.liveHomeImg || 'image/eRZE3TcwP5PFTffTc5X7muvfuHvggtXz.jpg',
          miniCardImg: form.miniCardImg,
          vipCardTypeIds: form.vipCardType.filter((item) => item !== -1).join(',')
        }
        if (this.form.type == 1 && this.form.rtmpType == 6) {
          // 620新直播
          postData.appGiveStyle = form.appGiveStyle
          postData.liveHomeImg = form.liveHomeImg
          postData.backgroundUrl = form.backgroundUrl || this.defaultLiveBg
          postData.liveBgPic = form.liveBgPic
          postData.category = form.category
          postData.liveVideoUrl = ''
          // postData.cutSplicingState = form.cutSwitch
          // postData.cutStartVideo = form.videoTitle
          // postData.cutEndVideo = form.videoEnd
          // 是否支持游客观看
          postData.isTouristWatch = form.isTouristWatch
          // 签到设置按钮
          postData.signState = form.signSwitch
          // 直播开播前多少分钟签到
          postData.liveSignIn = form.signInTime
          // 签到提示文案
          postData.liveSignInText = form.signSwitch && form.signInTime ? form.signInTips : ''
          // 直播结束后多少分钟签退
          postData.liveSignOut = form.signOutTime
          // 签退提示文案
          postData.liveSignOutText = form.signSwitch && form.signOutTime ? form.signOutTips : ''
          // 自定义签到
          postData.signTimes = form.custom
          // 回放类型
          postData.playbackType = form.playBack
          postData.playbackSource = form.playbackSource
          postData.playbackUrl = form.playbackUrl
          // 观看直播的入会密码
          postData.livePassword = form.passwordSwitch ? form.password : ''
          // APP值守人员的id
          postData.assistantId = form.watchMan ? form.watchMan.id : ''
          // WAP引导APP相关参数
          postData.wapGuideButtonText1 = form.wapGuideButtonText1
          postData.wapGuideButtonText2 = form.wapGuideButtonText2
          postData.wapLiveChatText = form.wapLiveChatText
          postData.isOpenWapReview = form.isOpenWapReview
          if (!form.isOpenWapReview) {
            postData.wapGuideVideoUrl = form.wapGuideVideoUrl
            postData.wapGuideVideoName = form.wapGuideVideoName
            postData.wapGuideVideoMode = this.wapGuideVideoCyclePlay ? 1 : 0
          }
          let teacahrIds = []
          for (let i = 0; i < form.teacahrIds.length; i++) {
            teacahrIds.push(form.teacahrIds[i].userId)
          }
          postData.teacahrIds = teacahrIds.join(',')

          // 视频直播
          if (this.form.category == 2) {
            postData.liveVideoUrl = form.liveVideoUrl
          }
          if (this.form.propagandaVideo && this.form.propagandaVideo.name && this.form.propagandaVideo.url) {
            postData.propagandaVideo = form.propagandaVideo
            if (this.propagandaCyclePlay) {
              postData.propagandaVideo.mode = 'LOOP'
            } else {
              postData.propagandaVideo.mode = 'ONCE'
            }
          }
          postData.fileId = form.vodId
          postData.fileName = form.vodName
        } else if (this.form.type == 2) {
          postData.fileId = form.vodId
          postData.fileName = form.vodName
        } else if (this.form.type == 8) {
          postData.fileId = form.vodId
          postData.fileName = form.audioName
          postData.sourceExtra = {
            url: form.webUrl,
            classInfo: this.content,
            liveVideoUrl: (postData.liveVideoUrl = form.liveVideoUrl)
          }
        }

        // 添加额外信息
        Object.assign(postData, extraData, this.copyright)
        this.isPublish = extraData.offline != undefined ? true : false

        // 执行添加操作
        this.buttonIsLoading = true
        let api
        if (this.sourceId && this.pageType !== 'COPY') {
          api = courseSourceReq.editCourseSource
        } else {
          api = courseSourceReq.addCourseSource
        }
        api(postData)
          .then((res) => {
            if (res.Success) {
              this.$message.success('保存成功')
              this.closePage()
            } else {
              this.$message.error(res.Msg)
              this.buttonIsLoading = false
            }
          })
          .finally(() => {})
          .catch((e) => {
            console.log(e)
            this.buttonIsLoading = false
          })
      }
    },

    // 发布
    publish() {
      this.saveHandle({
        offline: 0
      })
    },

    //取消钩子
    closePage() {
      this.$store.dispatch('tabs/removeSpecifiedTab', this.PAGEKEY)
      this.$store.dispatch('tabs/toTargetTab', this.PAGEBACK)
    },

    //取消选择
    cancleChoiceTag(index) {
      this.form.choicedTag.splice(index, 1)
    },

    //打开选择医生组件
    openDocSelectDialog() {
      this.$refs.selectDocDialog.open('选择医生')
    },

    //医生组件选择回调
    choiceDocCallback(choiceDoctor) {
      this.form.teacher.name = choiceDoctor.realName
      this.form.teacher.id = choiceDoctor.id
    },

    //打开选择小助手组件
    openAssistantSelectDialog() {
      this.$refs.selectAssistantDialog.open('选择主持人')
    },

    //小助手组件选择回调
    choiceAssistantCallback(choiceData) {
      this.form.assistant.name = choiceData.nickName
      this.form.assistant.id = choiceData.id
    },

    //打开标签dialog
    openTagDialog() {
      this.$refs.selectTag.open('选择标签')
    },
    choiceVodHandle() {
      $('#uploadVideoNow-file').click()
    },
    choiceVodForPropagandaHandle() {
      $('#uploadVideoForPropaganda-file').click()
    },

    // 上传视频
    uploadLiveVideoBefore() {
      this.form.liveVideoUrl = ''
    },
    uploadLiveVideoSuccess(response) {
      let { url } = response
      this.form.liveVideoUrl = url
      this.$message.success('上传成功')
    },
    removeTag(index) {
      this.form.teacahrIds.splice(index, 1)
    },

    // 打开更多讲者列表
    openDocAll(ref) {
      this.$refs[ref].open('选择医生')
    },

    //更多讲者选择回调
    choiceMoredocCallback(data) {
      let str = JSON.stringify(this.form.teacahrIds)
      for (let i = 0; i < data.length; i++) {
        if (str.indexOf(data[i].id) != -1) {
          continue
        }
        this.form.teacahrIds.push({
          userId: data[i].id,
          userName: data[i].nickName
        })
      }
    },

    // 直播间封面
    beforeUpload(file) {
      this.$message.success('正在上传...')
    },
    beforeUploadBgCover(file) {
      if (!file.type.includes('image')) {
        this.$refs.bgUpload.abort(file)
        this.$message.error('请上传图片类型')
        return false
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$refs.bgUpload.abort(file)
        this.$message.error('当前上传的图片已超过2M，无法上传，请重新选择')
        return false
      } else if (file.size > 1024 * 1024) {
        this.$message.warning('当前上传的图片已超过1M，将有不可显示的风险')
      }
    },
    uploadSuccess(name, res) {
      res = this.$apiOldResDeal(res)
      if (!res.Success) {
        this.$message.error(res.Msg)
      } else {
        this.form[name] = res.Data.url
        this.$forceUpdate()
        this.$message.success('上传成功')
      }
    },

    // 删除封面
    deleteCover(name) {
      this.form[name] = ''
      this.$forceUpdate()
    },

    // 数据太复杂，无法实时更新dom
    updateDom(val) {
      this.$forceUpdate()
    },
    // 课程源
    //打开选择课程源
    openSelectCourseOrgin() {
      this.$refs.selectCourseOrgin.getData()
      this.$refs.selectCourseOrgin.open('选择课程源')
    },
    // 选择课程源回调
    choiceCourseCallback(courseOrgin) {
      this.source = courseOrgin[0]
    },
    //添加标签
    addTag(tagCategoryId, tagName) {
      return new Promise((resolve, reject) => {
        let data = {
          tagCategoryId: tagCategoryId,
          tagNames: [tagName]
        }
        if (tagName == '') {
          return
        }
        courseSourceReq
          .addBatchTag(data)
          .then((res) => {
            if (res.Success) {
              resolve()
            } else {
              reject()
              this.$message.error(res.Msg)
            }
          })
          .catch((res) => {
            this.$message.error('添加出错啦，请刷新重试！')
          })
      })
    },
    choiceTagCb(data) {
      let str = JSON.stringify(this.form.choicedTag)
      for (let i = 0; i < data.length; i++) {
        if (str.indexOf(data[i].id) != -1) {
          continue
        }
        this.form.choicedTag.push({
          id: data[i].id,
          name: data[i].title
        })
      }
    },
    // 上传音频
    uploadVoiceBefore(file) {
      let type = file.type.toLowerCase()
      let nameType = file.name.toLowerCase()
      if (type.indexOf('mp3') == -1 && nameType.indexOf('mp3') == -1) {
        this.$message.error('请上传MP3格式的音频')
        return false
      } else {
        this.$message.info('开始上传，请稍后')
      }
    },
    uploadPropagandaSuccessCb(response) {
      let { url, file } = response
      this.form.propagandaVideo.url = url
      this.form.propagandaVideo.name = file.name
      this.$message.success('上传成功')
    },
    clearPropagandaVideo() {
      this.form.propagandaVideo.url = ''
      this.form.propagandaVideo.name = ''
      this.form.propagandaVideo.mode = ''
      this.propagandaCyclePlay = false
    },
    // wap引导视频 上传成功
    uploadWapGuideVideoSuccessCb(response) {
      let { url, file } = response
      this.form.wapGuideVideoUrl = url
      this.form.wapGuideVideoName = file.name
      this.$message.success('上传成功')
    },
    // wap引导视频 移除
    clearWapGuideVideo() {
      this.form.wapGuideVideoUrl = ''
      this.form.wapGuideVideoName = ''
      this.form.wapGuideVideoMode = 1
      this.wapGuideVideoCyclePlay = true
    },
    copy(id) {
      let configUrl = document.getElementById(id)
      configUrl.select()
      document.execCommand('copy')
      this.$message.success('复制成功！')
    },
    // 添加自定义时间
    addCustomTime() {
      // 是否填写完自定义标签时间
      const nofilledList = this.form.custom.filter((item) => {
        if (!item.startTime && !item.endTime) {
          return item
        }
      })
      console.log('-----------', nofilledList)
      if (nofilledList.length !== 0) {
        this.$message.error('请先填写现有的自定义签到时间')
        return
      }
      this.form.custom.push({
        time: '',
        startTime: '', // 签到开始时间
        endTime: '', // 签到结束时间
        text: '' // 自定义签到文案
      })
    },
    // 删除自定义签到时间
    deleteCustomTime(index) {
      this.form.custom.splice(index, 1)
    },
    // 选择日期
    timePickerChange(item, index) {
      item.startTime = item.time ? item.time[0] : ''
      item.endTime = item.time ? item.time[1] : ''
      this.form.custom.forEach((cusItem, cusIndex) => {
        if (!cusItem.startTime) return
        if (
          new Date(item.startTime).getTime() <= new Date().getTime() ||
          new Date(item.endTime).getTime() <= new Date().getTime()
        ) {
          item.time = ''
          this.$message.error('自定义签到时间不能早于当前时间')
          return
        }
        if (new Date(cusItem.startTime).getTime() === new Date(cusItem.endTime).getTime()) {
          item.time = ''
          this.$message.error('签到开始时间、结束时间最少间隔一分钟')
          return
        }
        if (!item.time) return
        if (index !== cusIndex) {
          const itemStart = new Date(item.startTime)
          const cusStart = new Date(cusItem.startTime)
          const itemEnd = new Date(item.endTime)
          const cusEnd = new Date(cusItem.endTime)
          // 当前开始时间大于其他开始时间，当前开始时间大于其他结束时间
          // 且当前开始时间小于其他开始时间，当前结束时间小于其他开始时间
          if (!(itemStart > cusStart && itemStart > cusEnd) && !(itemStart < cusStart && itemEnd < cusStart)) {
            item.time = ''
            this.$message.error('自定义签到有时段存在重叠，请重新设置')
            return
          }
        }
      })
      this.$forceUpdate()
    },
    // 添加app值守人员
    choiceWatchManCallback(data) {
      this.form.watchMan.id = data.id
      this.form.watchMan.name = data.realName
      this.form.watchMan.phone = data.phone
    },
    // 删除app值守人员
    removeAppTag() {
      this.form.watchMan.name = ''
      this.form.watchMan.id = ''
      this.form.watchMan.phone = ''
    }
  }
}
</script>

<style type="text/less" lang="less" scoped>
.addField {
  display: flex;
  .inp1 {
    width: 100px;
    margin: 0 10px;
  }
  .inp2 {
    width: 300px;
    margin: 0 10px;
  }
}
.title {
  display: flex;
  align-items: center;
}
.desc {
  color: grey;
  font-size: 12px;
  margin: 0px 10px;
  opacity: 0.7;
}
.courseList {
  width: 1380px;
  margin-bottom: 10px;
  margin-left: 30px;

  .courseList_title {
    width: 50%;
  }

  .courseList_opearte {
    float: right;
    padding: 3px 0 3px 5px;
  }
}
.self-el-card {
  margin-bottom: 20px;
}
.sign_time {
  padding: 10px 20px;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  .sign_start {
    display: flex;
    align-items: center;
  }
  .time_input {
    margin: 0 10px;
    width: 120px;
  }
  .tips_input {
    margin: 0 5px;
    width: 280px;
  }
}
.custom_sign {
  display: flex;
  margin-top: 30px;
}

.self-el-tag {
  margin-right: 10px;
}
.tag-wrap {
  .self-tag-item {
    cursor: pointer;
    margin-right: 10px;
  }
  .self-tag-choiced {
    display: none;
    // color: #909399;
    // background-color: hsla(220, 4%, 58%, 0.1);
    // border-color: hsla(220, 4%, 58%, 0.2);
  }
}
.choiced-tag-wrap {
  .self-tag-item {
    cursor: pointer;
    margin-right: 10px;
  }
}
.avatar-uploader {
  display: inline-block;
  i {
    // font-size: 40px;
  }
  .avatar {
    width: 80px;
    height: 80px;
  }
}
.add-tag-link {
  position: absolute;
  right: 20px;
  transform: translateY(20px);
  cursor: pointer;
  font-size: 14px;
  color: #909399;
  text-decoration: underline;
}
.self-progress {
  width: 21%;
  min-width: 300px;
  margin-top: 10px;
  display: inline-block;
  .el-progress-bar__innerText {
    transform: scale(0.8) translateY(-4px);
  }
}
.color-list {
  display: flex;
  flex-wrap: wrap;
  .color-item {
    position: relative;
    width: 150px;
    height: 100px;
    margin: 5px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #f2f2f2;
    .img-mini {
      width: 100%;
      height: 100%;
    }
    .icon-close {
      position: absolute;
      right: 0;
      top: 0;
      background-color: red;
      color: #fff;
      border-radius: 50%;
      transform: translate(50%, -50%);
    }
  }
}
.preview-img-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 1);
  z-index: 9999;
  .img-item {
    width: 80%;
    max-width: 80%;
    max-height: 80%;
    background-size: 100% 100%;
  }
}
.preview-img-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  .img-item {
    width: 80%;
    max-width: 80%;
    max-height: 80%;
    background-size: 100% 100%;
  }
}
.width_short_half {
  width: 10%;
  min-width: 150px;
}
.teachStyle {
  div {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 16px 0;
    color: #c1c1c1;
    border-radius: 10px;
    border: 1px solid #c1c1c1;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      &:nth-child(2) {
        display: none;
      }
    }
    p {
      margin: 0;
    }
    &.active {
      color: #37c8db;
      border-color: #37c8db;
      img:nth-child(1) {
        display: none;
      }
      img:nth-child(2) {
        display: block;
      }
    }
  }
}
.avatar {
  height: 81px;
}
/deep/ .icon-picture-add {
  font-size: 70px;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/contentManage/courseSourceManage/components/courseSourcePage.vue